import React, { Component } from 'react';
import office from '../assest/images/office.svg';
class About extends Component {

    render() {
        return (
            <div id='about-container' className='about-container'>
                <div style={{ width: '100%' }}>
                    <div className="container">
                        <h1 className="text-center about-heading ">ABOUT ME</h1>
                        <div className="about-border">
                            <div className="about-child-border" />
                        </div>
                        <p className="text-center about-intro">Here you will find more information about me,
                            what I do, and my current skills mostly in terms of
                            programming and technology</p>
                    </div>
                    <div className="about-info">
                        <div data-aos="fade-right"
                            data-aos-offset="300"
                            data-aos-easing="ease-in-sine">
                            <h3 className="about-title">Get to know me!</h3>
                            <div className="about-paragraph">
                               Hello! My name is Aman Gupta,
                               I have done my graduation in Electronics and Communication Engineering in 2021.
                            </div>
                            <div className="about-paragraph"> I enjoy creating things that are live on internet.
                                My interest is frontend, backend and app developement.
                                I always play with code and do some experiments.
                            </div>
                        </div>
                        <div
                            data-aos="fade-left"
                            data-aos-offset="300"
                            data-aos-easing="ease-in-sine"
                            className='about-image'>
                            <img src={office} alt={'about'} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default About;